import { IWindowSize } from "src/hooks";

interface IWidth {
  customMaxWidth: number;
  customLaptopLWidth: number;
  customLaptopWidth: number;
  customTabletWidth: number;
}

const generateSliderSettings = (size: IWindowSize, width: IWidth) => {
  const settings = {
    autoplay: true,
    centerMode: true,
    variableWidth: true,
    adaptiveHeight: true,
    dots: false,
    infinite: true,
    /* focusOnSelect: true, */
    speed: 2000,
    autoplaySpeed: 5000,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 3,
    rows: 1,
  };

  if (size.width > width.customMaxWidth) {
    settings.slidesToShow = 4;
  }
  if (size.width < width.customMaxWidth && size.width > width.customLaptopLWidth) {
    settings.slidesToShow = 3;
  }
  if (size.width < width.customLaptopLWidth + 10 && size.width > width.customLaptopWidth) {
    settings.slidesToShow = 2;
  }
  if (size.width < width.customLaptopWidth + 2) {
    settings.slidesToShow = 1;
  }
  if (size.width < width.customTabletWidth) {
    settings.rows = 1;
  }

  return settings;
};

export default generateSliderSettings;
